export const vi_tri = {
  HOME_TOP_SLIDERS_MTA: "home-top-sliders-mta",
};

export const slug = {
  HOMEPAGE: "ora-park-landingpage",
  SLIDERCONTENT: "noi-dung-home-slider",
  FOOTER: "footer",
};
export const collection_name = {
  APP: "app",
  ECOM_PRODUCT_LINES: "ecomproductlines",
  NEWS: "news",
  ECOM_BANNERS: "ecombanners",
  ECOM_PAGES: "ecompages",
  ECOM_CONTACTUS: "ecomcontactus",
};

export const type = {
  COUNT: "count",
  LIST: "list",
  DETAIL: "detail",
};
export const staleTime = {
  DEFAULT: 1000 * 60 * 1, // 1 minute
  LONG: 1000 * 60 * 5, // 5 minutes
  SHORT: 1000 * 60 * 10, // 10 seconds
};
